import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";
import Logout from "../api/logout";

const Header = ({ 
  searchParam,
  onOpenSnthsHstry,
  onOpenNtfcPopup,
  onChange,
  ntfcIconRef 
}) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false); // 로그인여부
  const navigate = useNavigate();

  const [selectedCategory, setSelectedCategory] = useState("U"); // 최초 조회조건
  const [keyword, setKeyword] = useState(""); // 조회할 키워드

  useEffect(() => {
    const tokenExists = document.cookie.includes("isLogined=true"); //토큰 검사
    setIsLoggedIn(tokenExists);

    onSearch();
  }, []);

  useEffect(() => {
    if (searchParam) {
      setKeyword(searchParam.keyword ?? "");        // 빈 문자열도 반영
      setSelectedCategory(searchParam.category ?? "ALL");
    }
  }, [searchParam]);
  

  const handleLogin = () => {
    navigate("/login");
  };

  const onSearch = async () => {
    onChange({
      category: selectedCategory,
      keyword: keyword
    });
  };

  return (
    <header className="top-header">
      <div className="header-inner">
        <div className="center">
          <div className="search-container">
            <select
              className="search-select"
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
                <option value="ALL">전체</option>
                <option value="F">함수</option>
                <option value="G">그리드</option>
                <option value="D">데이터셋</option>
                <option value="C">컴포넌트</option>
                <option value="U">공통모듈</option>
                <option value="E">기타</option>
              </select>
              <input
                type="text"
                placeholder="Quick search..."
                className="search-input"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    onChange?.({
                      category: selectedCategory,
                      keyword: keyword
                    });
                  }
                }}
              />
              <button className="search-btn" onClick={()=>{
                onSearch();
              }}>조회</button>
          </div>
        </div>

        <div className="right">
          {/* 알림 아이콘 */}
          <span className="icon">
            <a className="icon-notice" ref={ntfcIconRef} onClick={onOpenNtfcPopup}></a>
          </span>
          {/* 이력 아이콘 */}
          <span className="icon">
            <a className="icon-history" onClick={onOpenSnthsHstry}></a>
          </span>

          {isLoggedIn ? (
            // 로그아웃 아이콘
            // 컴포넌트화
            <Logout></Logout>
          ) : (
            // 로그인 아이콘
            <span className="icon">
              <a className="icon-login" onClick={handleLogin}></a>
            </span>
          )}

          {/* 설정 아이콘 */}
          <span className="icon">
            <a className="icon-setting" onClick={() => navigate('/docMng')}></a>
          </span>
        </div>
      </div>
    </header>
  );
};

export default Header;